var map = {
	"./tips/high-amortization.tsx": 9573,
	"./tips/high-ltv.tsx": 9748,
	"./tips/interest-discount-move-loan.tsx": 4110,
	"./tips/interest-discount-new-loan.tsx": 1095,
	"./tips/low-kalp-component.tsx": 9116,
	"./tips/low-kalp-move-loan.tsx": 3079,
	"./tips/low-kalp-new-loan.tsx": 5956
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7265;